import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import offeredLocales from './locales/offered-locales.json';

// Single source of truth for which languages this build offers: the same
// apps/smartpoker/src/locales/offered-locales.json also drives
// scripts/check_locale_parity.mjs's required-parity set. Two lists that can
// drift is the bug class #171 existed to close — de/fr/it/pt are
// machine-translated drafts (see apps/smartpoker/src/locales/unsupported/)
// that are not reviewed and must not be selectable until they are.
const translationsByCode: Record<string, object> = { en, es };

export const SUPPORTED_LANGUAGES = offeredLocales;

const resources = Object.fromEntries(
  offeredLocales.map(({ code }) => [code, { translation: translationsByCode[code] }])
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: offeredLocales.map((l) => l.code),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
